import React, { useState } from "react";
import img1 from "../Assets/img1.png";
import img2 from "../Assets/admissionbg.png";
import img3 from "../Assets/admissionleftbg.png";
import admission from "../Assets/admission.png";
import PhoneInput from "react-phone-input-2";
import SummaryApi from "../common/index";
import { useNavigate } from "react-router-dom"; // for navigation
import Cookies from "js-cookie"; // to handle cookies
import CustomDialog from "./CustomDialog";

const Admissions = () => {
  const [studentName, setStudentName] = useState("");
  const [studentNumber, setStudentNumber] = useState("");
  const [parentName, setParentName] = useState("");
  const [parentNumber, setParentNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [isError, setIsError] = useState(false);
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    password: "",
    address: "",
  });
  const navigate = useNavigate(); // useNavigate for navigation

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [isValidPhone, setIsValidPhone] = useState(true);

  const handlePhoneChange = (e) => {
    const value = e.target.value;

    // Remove any non-numeric characters
    const cleanedValue = value.replace(/[^0-9]/g, '');
    
    // Set the cleaned value and update validity
    setStudentNumber(cleanedValue);
    setIsValidPhone(cleanedValue.length === 10);
  };

  const validatePhoneNumber = () => {
    const cleanedNumber = studentNumber.replace(/[^0-9]/g, "");
    if (cleanedNumber.length !== 10) {
      setIsValidPhone(false);
      //alert("Please enter exactly 10 digits for the phone number.");
      return false;
    }
    setIsValidPhone(true);
    return true;
  };

  // Mark handleSubmit as async
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure the phone numbers are exactly 10 digits
    if (studentNumber.replace(/[^0-9]/g, "").length !== 10) {
      // alert("Please enter exactly 10 digits for the phone number.");
      return;
    }

    const payload = {
      full_name: studentName, // Use studentName here
      mobile_number: studentNumber.replace(/[^0-9]/g, ""), // Remove non-numeric characters
      email: email,
      address: address,
      interested_course: selectedCourse,
    };

    if (!selectedCourse) {
      setIsError(true); // Show error if no course is selected
      return;
    } else {
      setIsError(false); // Clear error if a course is selected
    }

    // Show alert with the selected course
    // alert(`Our Team will Contact You Soon.`);
    // Show success dialog
    setDialogMessage("Our Team will Contact You Soon.");
    setIsDialogVisible(true);

    // Clear all form data after submission
    setStudentName("");
    setStudentNumber("");
    setParentName("");
    setParentNumber("");
    setEmail("");
    setAddress("");
    setSelectedCourse("");

    console.log(payload);

    try {
      // Make the API call with fetch
      const response = await fetch(SummaryApi.createadmission.url, {
        method: SummaryApi.createadmission.method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      // Assuming the API returns the student ID in `data.student_id`
      if (data.student_id) {
        // Store student_id in cookies
        Cookies.set("student_id", data.student_id, { expires: 7 });
        // alert("Submit successful!");
        // Create a WhatsApp message with the form data
        const message = `
        *Enrollment Form Details:*
        *Student Name:* ${studentName}
        *Student Number:* ${studentNumber}
        *Email:* ${email}
        *Address:* ${address}
        *Selected Course:* ${selectedCourse}
      `;
        // URL encode the message
        const encodedMessage = encodeURIComponent(message);
        // WhatsApp number to send the details (replace with the target number)
        const whatsappNumber = "+918919311981"; // Replace with your target WhatsApp number
        // Construct the WhatsApp URL
        const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
        // Redirect the user to WhatsApp with the message
        window.location.href = whatsappURL;
        // Navigate to the home page
        navigate("/"); // Updated to use navigate instead of history.push
      } else {
        // Handle case when there is no student_id
      }
      console.log(data);
    } catch (error) {
      console.error("Error during registration:", error);
    }
  };

  const closeDialog = () => {
    setIsDialogVisible(false);
  };

  return (
    <div className="max-w-8xl mx-auto px-4">
     <h1 className="text-center text-2xl mt-5 font-bold w-[160px] border-b-2 border-gray-500 mx-auto">ADMISSIONS</h1>
{/* <hr className="border-b-2 border-gray-500 w-[12%] mx-auto mt-2" /> */}


      {isDialogVisible && (
        <CustomDialog message={dialogMessage} onClose={closeDialog} />
      )}

      {/* Header Image */}
      <div className="mb-2 mt-4">
        <img
          src={img1}
          alt="Admissions"
          className="w-full h-auto rounded-lg object-cover animate-fade-in"
        />
      </div>
      <div
  className="flex justify-between flex-col md:flex-row"
  style={{
    backgroundImage: `url(${img2})`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
  }}
>
        {/* Admission Details Section */}
        <div className="p-6 rounded-lg mb-5 pt-9 w-full md:w-[50%]">
          <h2 className="text-2xl font-semibold text-white text-gray-800 mb-4 ml-[10%]">
            REQUIRED DOCUMENTS
          </h2>
          <h2 className="text-2xl font-semibold  text-gray-800 mb-8 ml-[10%]">
            <span className="text-white">FOR</span>{" "}
            <span className="text-[#3FBEF0]"> ADMISSION</span>
          </h2>
          {/* <div className="flex flex-col md:flex-row sm:m-[-5%] md:m-[0%] lg:m-[0%] xl:m-[0%] 2xl:flex-row justify-between w-[80%] mx-auto"></div> */}
          <div className="flex flex-col  xl:flex-row 2xl:flex-row justify-between w-[80%] mx-auto">
            <div
              style={{
                backgroundImage: `url(${img3})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }}
              className=" pl-5 w-[100%] rounded  mt-1 pb-2"
            >
              <div className="space-y-7 text-xl text-white pt-7">
                <div className="flex items-center">
                  <span className="mr-2 text-4xl">&#8226;</span>
                  <span>4<sup>th</sup> to 10<sup>th</sup> Study Certificate</span>

                </div>
                <div className="flex items-center">
                  <span className="mr-2 text-4xl">&#8226;</span>
                  <span>SSC Marks Memo</span>
                </div>

                <div className="flex items-center">
                  <span className="mr-2 text-4xl">&#8226;</span>
                  <span>Transfer Certificate (TC)</span>
                </div>
                <div className="flex items-center">
                  <span className="mr-2 text-4xl">&#8226;</span>
                  <span>POLYCET Hall Ticket</span>
                </div>
                <div className="flex items-center">
                  <span className="mr-2 text-4xl">&#8226;</span>
                  <span>POLYCET Rank Card</span>
                </div>
                <div className="flex items-center">
                  <span className="mr-2 text-4xl">&#8226;</span>
                  <span>EWS Certificate for OC Students</span>
                </div>
                <div className="flex items-center">
                  <span className="mr-2 text-4xl">&#8226;</span>
                  <span>Caste Certificate</span>
                </div>
                <div className="flex items-center">
                  <span className="mr-2 text-4xl">&#8226;</span>
                  <span>Income Certificate</span>
                </div>
                <div className="flex items-center">
                  <span className="mr-2 text-4xl">&#8226;</span>
                  <span>Rice Card</span>
                </div>
                <div className="flex items-center">
                  <span className="mr-2 text-4xl">&#8226;</span>
                  <span>Photo</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-6 rounded-lg mb-5 pt-9 w-full md:w-[50%]">
        <h2 className="text-2xl font-semibold text-white text-gray-800 mb-4 ">
            POLYCET COLLEGE CODE
          </h2>
          <h2 className="text-3xl font-semibold  text-gray-800 mb-8 ">
            <span className="text-[#3FBEF0]">JPKP</span>
          </h2>
          <form
            className="w-full max-w-4xl bg-white p-8 rounded-lg shadow-xl border border-gray-200"
            onSubmit={handleSubmit}
          >
            <h2 className="text-3xl font-extrabold mb-1 text-gray-800 text-center">
              Online Submission Form
            </h2>
            <p className="text-lg font-extrabold mb-6 text-gray-400 text-center">
              Please enter all the details below.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              {/* Student Name */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Student Name <span className="text-red-500"></span>
                </label>
                <input
                  type="text"
                  value={studentName}
                  onChange={(e) => setStudentName(e.target.value)}
                  placeholder="Student Name"
                  className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                />
              </div>

              {/* Student Number */}
              <div>
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Phone Number <span className="text-red-500">*</span>
        </label>
        <input
          type="tel"
          value={studentNumber}
          onChange={handlePhoneChange}
          style={{
            width: "100%",
            borderRadius: "0.5rem",
            border: `1px solid ${isValidPhone ? "#d1d5db" : "#f87171"}`,
            padding: "10px",
          }}
          placeholder="Enter phone number"
          required
          maxLength={10}
        />
        {/* Display the error message only if the phone number is invalid and not exactly 10 digits */}
        {!isValidPhone && studentNumber.length > 0 && (
          <p
            style={{
              color: "red",
              fontSize: "0.875rem",
              marginTop: "0.25rem",
            }}
          >
            Please enter exactly 10 digits for the phone number.
          </p>
        )}
      </div>

              {/* Parent Name */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Father/Mother Name <span className="text-red-500"></span>
                </label>
                <input
                  type="text"
                  value={parentName}
                  onChange={(e) => setParentName(e.target.value)}
                  placeholder="Father/Mother Name"
                  className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email <span className="text-red-500"></span>
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your Email"
                  className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                />
              </div>

              {/* Address */}
              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Address <span className="text-red-500"></span>
                </label>
                <textarea
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="Enter your address"
                  className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                  rows="4"
                />
              </div>

              {/* Course Selection */}
              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Select Course <span className="text-red-500">*</span>
                </label>
                <select
                  className="w-full border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 p-3"
                  value={selectedCourse}
                  onChange={(e) => setSelectedCourse(e.target.value)}
                  // required
                >
                  <option value="" disabled>
                    -- Select a Course --
                  </option>
                  <option value="ARTIFICIAL INTELLIGENCE AND MACHINE LEARNING">
                    ARTIFICIAL INTELLIGENCE AND MACHINE LEARNING
                  </option>
                  <option value="COMPUTER SCIENCE & ENGINEERING">
                    COMPUTER SCIENCE & ENGINEERING
                  </option>
                  <option value="ELECTRONICS & COMMUNICATION ENGINEERING">
                    ELECTRONICS & COMMUNICATION ENGINEERING
                  </option>
                  <option value="CIVIL ENGINEERING">CIVIL ENGINEERING</option>
                  <option value="ELECTRICAL & ELECTRONICS ENGINEERING">
                    ELECTRICAL & ELECTRONICS ENGINEERING
                  </option>
                  <option value="MECHANICAL ENGINEERING">
                    MECHANICAL ENGINEERING
                  </option>
                  <option value="CLOUD COMPUTING & BIG DATA">
                    CLOUD COMPUTING & BIG DATA
                  </option>
                </select>
                {isError && (
                  <p className="text-red-500 text-sm mt-1">
                    Please select course
                  </p>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-4">
              <button
                type="submit"
                className="w-full bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-blue-700 transition duration-300 shadow-md"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default Admissions;
